import { createRoot } from 'react-dom/client';
import { HotkeysProvider } from 'react-hotkeys-hook';

import { getEnvironment } from '@cartwhl/common/utils';
import { initDatadog } from '@cartwhl/tracking/datadog';

import ModalManager from 'components/organisms/ModalManager';
import Notices from 'components/organisms/Notices';
import PageManager from 'components/organisms/PageManager';

import './index.css';
import './stores';

const env = getEnvironment();

initDatadog({
  service: 'studio',
  env,
  isDevelopment: process.env.NODE_ENV === 'development',
});

// eslint-disable-next-line react-refresh/only-export-components
function App() {
  return (
    <HotkeysProvider>
      <div className="min-h-screen w-full">
        <Notices />
        <ModalManager />
        <PageManager />
      </div>
    </HotkeysProvider>
  );
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
